import * as actionTypes from "../actions/actionTypes";

const initialState = {
  licencia: null,
  docs: [],
  currentCuil: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LICENCIA_DOCUMENTS: {
      return {
        ...state,
        licencia: action.data,
      };
    }
    case actionTypes.SET_DOCUMENTS: {
      return {
        ...state,
        docs: action.payload.data,
        currentCuil: action.payload.cuil,
      };
    }
    default:
      return state;
  }
};

export default reducer;
